export type ILicense = ILicenseBase;

export enum ILicenseErrorCode {
    NoLicense = 1,
    LicenseExpired = 2,
    LicenseUnregistered = 3,
    NoAvailableLicenses = 4,
    NotEnoughAvailableSlots = 5,
    NotEnoughRuntimeLicenses = 6,
    LicenseIsAlreadyInUse = 7,
    InvalidRequest = 8,
    SlotsExceedLicenseLimit = 9,
    RuntimeDisabled = 10,
}

export enum LicenseServerErrorCode {
    ServerConnectionFailure = -1030,
    NotLicensed = -1020,
    AfterEndDate = -102,
}

export enum LicenseOfficeType {
    BackOffice = 'bo',
    FrontOffice = 'fo',
}

export enum LicenseConsumerType {
    User,
    Connection,
    Device,
}

export enum LicenseFormControl {
    installationId = 'installationId',
    licenseKey = 'licenseKey',
    environment = 'environment',
}

export enum LicenseErrorCode {
    NoLicense = ILicenseErrorCode.NoLicense,
    LicenseExpired = ILicenseErrorCode.LicenseExpired,
    LicenseUnregistered = ILicenseErrorCode.LicenseUnregistered,
    NoAvailableLicenses = ILicenseErrorCode.NoAvailableLicenses,
    NotEnoughAvailableSlots = ILicenseErrorCode.NotEnoughAvailableSlots,
    NotEnoughRuntimeLicenses = ILicenseErrorCode.NotEnoughRuntimeLicenses,
    LicenseIsAlreadyInUse = ILicenseErrorCode.LicenseIsAlreadyInUse,
    InvalidRequest = ILicenseErrorCode.InvalidRequest,
    SlotsExceedLicenseLimit = ILicenseErrorCode.SlotsExceedLicenseLimit,
    RuntimeDisabled = ILicenseErrorCode.RuntimeDisabled,
}

export enum LicenseEnvironment {
    Production = 'Production',
    NonProduction = 'NonProduction',
    Hybrid = 'Hybrid',
}

export enum OfflineState {
    UNDETERMINED,
    YES,
    NO,
    GENERATE,
}

export interface ILicenseBase {
    expirationDate: Date;
    gracePeriodEndDate: Date;
    allowed: ILicenseFields;
    used: ILicenseFields;
    isRegistered: boolean;
    isExpired: boolean;
    isCommunity: boolean;
    expiresSoon: boolean;
    features: Record<IndividuallyLicensedFeature, boolean>;
    attendedConcurrent: boolean;
    developmentConcurrent: boolean;
    studioXConcurrent: boolean;
    hostLicenseId: number;
    code: string;
    totals?: ILicenseFields;
}

export interface ILicenseFields {
    development: number;
    studioX: number;
    attended: number;
    unattended: number;
    nonProduction: number;
}

export enum LicenseFrontOfficeSource {
    Local,
    Orchestrator,
}

export interface ILicenseFrontOffice {
    key: string;
    activeRobotId: number;
    userName: string;
    lastLogin: Date;
    machines: number;
    machineNames: string;
    activeMachineNames: string[];
    displayMachineNames?: string;
    displayMachineNamesTooltip?: string;
    isLicensed: boolean;
    source: LicenseFrontOfficeSource;
}

export interface ILicenseBackOffice {
    key: string;
    machineId: number;
    isOnline: boolean;
    isLicensed: boolean;
    machineName: string;
    runtimes: number;
    executingCount: number;
    robotsCount: number;
    enabled: boolean;
}

export interface IHostLicense extends ILicenseBase {
    id: number;
    uploadDate: Date;
    tenantCount: number;
}

export interface ITenantLicense {
    tenantId: number;
    hostLicenseId: number;
    attended: number;
    unattended: number;
    nonProduction: number;
    development: number;
    studioX: number;
}

export interface ILicenseUpdated {
    eventTime: Date;
    key: string;
    tenantId: number;
}

export interface ILicenseUsageData {
    robotType: number;
    count: number;
    timestamp: Date;
}

export interface ILicenseRequest {
    installationId: string;
    licenseKey: string;
    environment: LicenseEnvironment;
    email?: string;
    update?: boolean;
    offline?: boolean;
    activationRequest?: string;
}

export interface ILicenseOfflineRequest {
    file: File;
    type: LicenseType;
}

export enum LicenseType {
    UiPath = 'UiPath',
    Legacy = 'Legacy',
}

export enum IndividuallyLicensedFeature {
    Analytics = 'ANL',
}
